import React from 'react';
import { Link } from 'react-router-dom';
import LucideIcon from '../LucideIcon';

interface ChecklistItem {
  label: string;
  to: string;
  checked: boolean;
}

interface ChecklistCardProps {
  title: string;
  items: ChecklistItem[];
}

// MainEmpty.dc.html's "Get set up" checklist -- square checkbox rows, not
// the circular radio style ChoiceCard uses elsewhere. Items link straight
// to the real feature they describe rather than being decorative text.
const ChecklistCard: React.FC<ChecklistCardProps> = ({ title, items }) => (
  <div className="ws-fade-up" style={{ animationDelay: '90ms', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 16, padding: 22 }}>
    <h3 className="ws-display" style={{ margin: '0 0 14px', fontSize: 14.5, fontWeight: 700, color: 'var(--text-primary)' }}>{title}</h3>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      {items.map((item) => (
        <Link
          key={item.label}
          to={item.to}
          className="ws-nav-link"
          style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 8px', borderRadius: 8, textDecoration: 'none' }}
        >
          <span
            style={{
              flex: '0 0 auto', width: 17, height: 17, borderRadius: 4,
              border: item.checked ? 'none' : '1.5px solid var(--border-strong)',
              background: item.checked ? 'var(--success)' : 'transparent',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            {item.checked && <span style={{ color: 'white', display: 'flex' }}><LucideIcon name="Check" size={11} /></span>}
          </span>
          <span style={{ fontSize: 13.5, fontWeight: 600, color: item.checked ? 'var(--text-tertiary)' : 'var(--text-secondary)', textDecoration: item.checked ? 'line-through' : 'none' }}>
            {item.label}
          </span>
        </Link>
      ))}
    </div>
  </div>
);

export default ChecklistCard;
